<template>
  <div class="row" v-if="sections.contentItems.length > 0">
    <div
      class="card border-0 mb-3"
      :class="getColumnClass(item.size)"
      v-for="(item, index) in sortedContentItems"
      :key="index"
    >
      <div class="row p-0 mt-3">
        <div class="col-12 d-flex  ">
          <div class="col-sm-2 pl-0" v-if="CustomStepTree[item.type].isCart">
            <span
              @click="!OrderSampleEnabled ? addItemToCart(item) : ''"
              class="png-icon mb-1 cursor-pointer"
              :class="
                OrderSampleEnabled
                  ? 'png-icon-icons-glyph--g-my-basket pointer-none'
                  : 'png-icon-icons-glyph--k-my-basket'
              "
            >
            </span>
          </div>
          <div
            class="col-sm-10 d-flex justify-content-end ml-auto pr-0"
            v-if="userRole"
          >
            <div class="custom-control">
              <input
                type="checkbox"
                :id="'board-card' + index"
                class="custom-control-input"
                @click="projectSelected(item.id)"
              />
              <label
                :for="'board-card' + index"
                class="custom-control-label"
              ></label>
            </div>
            <div class="btn-group">
              <div role="group" class="btn-group dropleft">
                <button
                  type="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  class="btn dropdown-toggle-split p-0"
                >
                  <span class="sr-only"></span>
                  <img
                    src="https://szue2patcraftblobpstb01.blob.core.windows.net/media/patcraft/media/patcraftmedia/frontendicons/ellipsis-vertical-solid.svg"
                    alt=""
                    style="width: 5px;"
                  />
                </button>
                <div
                  aria-labelledby="dropdownMenuLink"
                  class="dropdown-menu bg-white"
                >
                  <button
                    v-if="showHideEdit && (item.type == 0 || item.type == 9)"
                    @click.prevent="editColorImg(item)"
                    class="dropdown-item font-16"
                  >
                    {{
                      item.type == 0
                        ? $resourceString[
                            "myProject.Project.EditPage.Item.EditColorImage"
                          ]
                        : item.type == 9
                        ? $resourceString[
                            "myProject.Project.EditPage.Item.EditTrayDesign"
                          ]
                        : ""
                    }}
                  </button>

                  <button
                    v-if="showHideEdit"
                    @click.prevent="editContent(item)"
                    class="dropdown-item font-16"
                  >
                    {{
                      $resourceString[
                        "myProject.Project.EditPage.Item.EditSizeAndDesc"
                      ]
                    }}
                  </button>
                  <button v-if="(item.type == 9 && showDuplicateTrayButton(item)) && showHideEdit" @click.prevent="duplicateTray(item)" class="dropdown-item font-16">
                    {{
                      $resourceString[
                        "myProject.Project.EditPage.Item.DuplicateTray"
                      ]
                    }}
                  </button>
                  <div class="dropdown-divider" v-if="showHideEdit"></div>
                  <button
                    :class="{ disabled: isDisabled }"
                    class="dropdown-item font-danger font-16"
                    @click.prevent="handleDeleteProject(item)"
                  >
                    {{
                      $resourceString["myProject.Project.EditPage.Item.Delete"]
                    }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="row">
            <div class="col-12">
              <div class="image-grid-wrapp-mt-tray">
                <div v-if="item.type == 3"
                  class="align-items-center d-flex img-fluid justify-content-center mx-auto small-image-grid document-list"
                >
                  <img v-if="item.coverPhoto" :src="item.coverPhoto" alt="img" :class="isSVGEncodedDataURL(item.coverPhoto)?'show-icon h-50':'show-image h-100 w-100'"/>
                </div>
                <div v-else
                  class="d-block image-grid-my-tray-large img-fluid mx-auto "
                  :class="
                    item.size == 2 ? 'large-image-grid' : 'small-image-grid'
                  "
                >

                  <picture
                    class="w-100 img-comp wrapperClasses img-comp--glow-animation"
                  >
                    <img
                      v-if="item.coverPhoto"
                      :src="item.coverPhoto"
                      class="w-100 item-cover-img"
                      :alt="item.coverPhotoImageAltText || ''"
                    />
                  </picture>
                </div>
                <div
                  class="on-hover-background-card"
                  v-if="item.itemBoardId && item.type == 9"
                >
                  <a
                    :href="`/VirtualTray/EditTray/${item.itemBoardId}`"
                    ref="goToEditTray"
                    class="btn btn-outline-white-warn btn btn-outline-primary"
                    rel="noopener"
                    >{{ $resourceString["virtualtray.GoToTray.Msg"] }}</a
                  >
                </div>

                <div
                  class="on-hover-background-card"
                  v-if="item.type == 10"
                >
                  <a
                    @click.prevent.stop="onImgClick(item)"
                    class="btn btn-outline-white-warn btn btn-outline-primary"
                    rel="noopener"
                    >{{ $resourceString["common.Label.View"] }}</a
                  >
                </div>

                <div
                  class="on-hover-background-card"
                  v-if="item.type == 8"
                >
                  <a
                    :href="item.link"
                    class="btn btn-outline-white-warn btn btn-outline-primary"
                    rel="noopener"
                    target="_blank"
                  >
                    {{ $resourceString["myProject.Label.GotoPage"] }}
                  </a>
                </div>
              </div>
              <div
                class="bottom-icon"
                :class="item.size != 0 ? 'bottom-icon-large' : ''"
              >
                <my-project-colors-preview-icon
                  @colorPreview="showColorPreview($event)"
                  v-if="item.productContentItem"
                  :colors="item"
                ></my-project-colors-preview-icon>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 text-uppercase line-space">
          <div v-if="item.productContentItem">
            <a
              target="_blank"
              :href="
                $helpers.getProductDetailUrl(
                  item.link,
                  item.productContentItem.productId
                )
              "
              class="card-title product-list-title my-2"
            >
              {{ item.title + " - " + item.productContentItem.productId }} </a
            ><br />
            <a
              :href="getPdmsUrl(item.productContentItem.productId)"
              target="_blank"
              class="specification-link"
            >
              {{ item.title + " " + item.productContentItem.productId }}
              {{
                $resourceString[
                  "myProject.Project.EditPage.Item.SpecificationLink"
                ]
              }}
            </a>
          </div>
          <div v-if="item.type == 9">
            <a
              target="_blank"
              :href="`/VirtualTray/EditTray/${item.itemBoardId}`"
              class="card-title product-list-title black my-2"
            >
              {{ item.title }}
            </a>
          </div>
          <div v-if="item.type == 10">
            <span
              class="card-title product-list-title black my-2"
            >
              {{ item.title }}
            </span>
          </div>
          <div v-if="item.type == 3 || item.type == 8">
            <a :href="`/Product/ConstructionSpec/${getLink(item.title)}`" class="card-title product-list-title black my-2" v-if="item.link == 'True'">{{ item.title }}</a>
            <a v-else
              target="_blank"
              :href="item.link"
              class="card-title product-list-title black my-2"
            >
              {{ item.title }}
            </a>
          </div>
          <p class="card-title item-description black my-2">
            {{ item.description }}
          </p>
          <div>
            <div
              class="d-flex flex-wrap text-muted  justify-content-end text-size-small"
            ></div>
          </div>
        </div>
      </div>
    </div>

    <modal
      height="530"
      name="colors-preview-modal"
      data-html2canvas-ignore="true"
      :adaptive="true"
      :scrollable="true"
    >
      <my-project-color-preview-modal
        :productData="productData"
      ></my-project-color-preview-modal>
    </modal>

    <modal
      height="500"
      name="add-to-basket-modal"
      data-html2canvas-ignore="true"
      :adaptive="true"
      :scrollable="true"
    >
      <my-project-add-to-basket-modal></my-project-add-to-basket-modal>
    </modal>
    <!--Add to cart confirm modal -->
    <modal
      name="add-to-cart-confirm-modal"
      height="auto"
      data-html2canvas-ignore="true"
      :adaptive="true"
    >
      <pc-confirm-modal
        :header="$resourceString['myProject.add.to.basket.confirm.header']"
        :subheader="
          $resourceString['myProject.add.to.basket.confirm.subheader']
        "
        :close="closeAddToBasketConfirm"
        :isMyProject="vtId"
        :hidePopup="false"
      />
    </modal>
    <div id="vue-pc-inspiration-section-page">
      <pc-inspiration-images-gallery :isMyproject="true" />
    </div>
  </div>
  <div v-else class="container text-center">
    <p class="">{{ $resourceString["common.NoDataAvailable.Msg"] }}</p>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import myProjectColorsPreviewIcon from "./my-project-colors-preview-icon.vue";
import myProjectColorPreviewModal from "./my-project-color-preview-modal.vue";
import myProjectAddToBasketModal from "./my-project-add-to-basket-modal.vue";
import pcConfirmModal from "../virtual-tray/pc-vt-confirm-modal.vue";
import { ContentItemTypes, stepTree } from "../../../stepTree";
import cookies from "cookiesjs";
import WFLoadImage from ".././wf-load-image.vue";
import PcInspirationImagesGallery from "../inspiration-page/pc-inspiration-images-gallery.vue";
import patcraftApi from "../../../scripts/patcraft-api";
import {globalIcons} from "../../../constants/global"
export default {
  props: {
    col: Number,
    projectDetails: Object,
    userRole: Boolean
  },
  components: {
    myProjectColorsPreviewIcon,
    myProjectColorPreviewModal,
    myProjectAddToBasketModal,
    pcConfirmModal,
    "wf-load-image": WFLoadImage,
    PcInspirationImagesGallery
  },
  data() {
    return {
      sections: [],
      selectedItemId: [],
      productData: null,
      vtId: null,
      CustomContentItemTypes: ContentItemTypes,
      CustomStepTree: stepTree,
      icons:globalIcons
    };
  },

  created() {
    this.sections = this.projectDetails.boardDetails.sections.find(
      item => item.title == "default"
    );
    this.isOrderSampleEnabled();
  },

  computed: {
    ...mapGetters({
      getTrayDetails: "myProject/getTrayDetails",
      OrderSampleEnabled: "productDetail/getisOrderSampleEnabled",
      shareTrayId: "myTray/getShareTrayId"
    }),
    showHideEdit() {
      return this.selectedItemId?.length <= 1;
    },
    isDisabled() {
      return this.selectedItemId?.length === 0;
    },
    sortedContentItems() {
      return this.sections.contentItems
        .slice()
        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
    }
  },

  methods: {
    ...mapActions({
      deleteProjectFeatureItems: "myProject/deleteProjectFeatureItems",
      updateSelectedTrayId: "myTray/updateSelectedTrayId",
      getProductStyleNumbers: "contentWizard/getProductStyleNumbers",
      setProductItemDetails: "contentWizard/setProductItemDetails",
      resourceStringMyProject: "myProject/resourceString",
      fetchTrayDetails: "myProject/fetchTrayDetails",
      setColors: "contentWizard/setColors",
      isOrderSampleEnabled: "productDetail/isOrderSampleEnabled",
      resetContent: "contentWizard/resetContent",
      setImgPreviewOpened: "inspirationPage/setImgPreviewOpened",
      setOpenedImage: "inspirationPage/setOpenedImage",
      updateTranding: "inspirationPage/updateTranding",
      createTray: "myTray/createTray",
      getCartItemsForDuplicateTray: "myProject/getCartItemsForDuplicateTray",
      createProductItem: "myProject/createProductItem",
      resourceString: "myTray/resourceString",
      trayAlreadyExistResourceString: "myTray/trayAlreadyExistResourceString",
    }),

    showDuplicateTrayButton(item) {
      return this.projectDetails?.trayStatus[item.itemBoardId] !== 1;
    },

    getLink(item){
      // Pattern to match the last part after the last hyphen
      const regex = /-([^-]+)$/;
      const match1 = item.match(regex);
      return match1 ? match1[1] : null;
    },

    isSVGEncodedDataURL(url) {
      return url.startsWith('data:image/svg+xml');
    },

    onImgClick(image) {
      let payload = {
        OrderColumn: "DisplayCollectionName",
        SortBy: "DisplayCollectionName",
        PageNumber: 1,
        IncludeTotalResultCount: true,
        PageSize: 400,
        SearchTerm: image.title,
        IsAscendingOrder: false
      };
      patcraftApi
        .getInspirationImages(payload)
        .then(resp => {
          let assetData = resp?.data?.items;
          let imgData = assetData.filter(item => item.id == image.itemBoardId);
          if(imgData?.length>0){
            this.setOpenedImage(...imgData);
            this.setImgPreviewOpened(true);
            this.$helpers.disableScrolling();
            this.updateTranding({ widenAssetId: image.itemBoardId });
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    getPdmsUrl(word) {
      if (word) {
        let string = word.charAt(0).toLowerCase() + word.slice(1);
        return this.projectDetails?.pdmsLink[string];
      }
    },

    async duplicateTray(itemData, count = 0, CartItems = []){
      let newData = {
        CreateBoardDetail: {
          culture: "en-us",
          title: "Copy of " + itemData.title + (count == 0 ? "" : ` (${count})`),
          description: itemData.description,
          row: itemData.row,
          column: itemData.column,
          croppedBlobs: {
            thumbnail: ""
          },
          coverImageCroppings: [],
          coverImage: {
            assetId: itemData.coverPhotoStyleId
          },
          coverPhoto: itemData.coverPhoto,
          isBrandBoard: true,
          accessLevel: null,
          type: 0,
          siteProjectName: "VirtualTray"
        },
        CartItems: count == 0 ? await this.getCartItemsForDuplicateTray(itemData.itemBoardId) : CartItems
      };
      await this.resourceStringMyProject(
        this.$resourceString["common.accounts.Created.Msg"]
      );
      await this.resourceString(
        this.$resourceString["virtualtray.Tray.Created.Msg"]
      );
      await this.trayAlreadyExistResourceString(
        this.$resourceString["virtualTray.Request.DuplicateName"]
      );
      const res = await this.createTray({trayDetail: newData, isCallFromMyProject: true});
      if(res == true){
        let sectionId = this.projectDetails?.boardDetails.sections.find(
          item => item.title == "default"
        );
        let newDataForItemCreation = {
          boardId: this.shareTrayId,
          contentItem: {
            title: newData.CreateBoardDetail.title,
            description: newData.CreateBoardDetail.description,
            coverPhoto: newData.CreateBoardDetail.coverPhoto,
            coverPhotoImageAltText: newData.CreateBoardDetail.title,
            thumbnailUrl: "",
            link: null,
            type: itemData.type,
            size: itemData.size,
            row: 1,
            column: 1,
            sectionId: sectionId.id,
            isItemSelected: false,
            seoUrl: "",
            collectionCode: "",
            itemBoardId: this.shareTrayId
          },
          productContentItem: {
            productStyleImages: [],
            savedImages: []
          }
        };
        if(await this.createProductItem(newDataForItemCreation) == true)
        {
          window.location.reload();
        }
      }
      else if(res == 409){
        this.duplicateTray(itemData, count+1, newData.CartItems);
      }
    },

    showColorPreview(value) {
      this.productData = value;

      this.getProductStyleNumbers({
        filter: {
          OrderColumn: "OriginalActivationDate",
          IsAscendingOrder: false,
          Filter: "",
          IsEnabledOnSite: true,
          IsDisabledOnSearch: false,
          SellingStyleNumber: this.productData.colors.productContentItem
            .productId,
          PageSize: 200
        }
      });

      this.showModal("colors-preview");
    },

    closeAddToBasketConfirm() {
      this.hideModal("add-to-cart-confirm");
    },

    showModal(name) {
      this.$modal.show(name + "-modal");
    },

    hideModal(name) {
      this.$modal.hide(name + "-modal");
    },

    async addItemToCart(item) {
      if (item.productContentItem) {
        this.setColors({
          colors: item.productContentItem.productStyleImages,
          styleNumber: item.productContentItem.productId
        });
        this.showModal("add-to-basket");
      } else {
        const trayCartToken = cookies("traycart");
        if (trayCartToken) {
          this.showModal("add-to-cart-confirm");
          this.vtId = item.itemBoardId;
        } else {
          await this.fetchTrayDetails(item.itemBoardId);
        }
      }
    },

    editContent(item) {
      this.$emit("editContent", item);
    },
    async editColorImg(item) {
      if (item.type == 9)
        return (window.location.href = `/VirtualTray/EditTray/${item.itemBoardId}`);
      this.resetContent();
      await this.setProductItemDetails(item);
      await this.getProductStyleNumbers({
        filter: {
          OrderColumn: "OriginalActivationDate",
          IsAscendingOrder: false,
          Filter: "",
          IsEnabledOnSite: true,
          IsDisabledOnSearch: false,
          SellingStyleNumber: item.productContentItem.productId,
          PageSize: 200
        }
      });
      await this.$emit("editColorImg", item);
    },
    getColumnClass(size) {
      return {
        "col-md-6 col-sm-12 col-lg-4": size == 0,
        "col-md-10 col-sm-12 col-lg-8": size == 1,
        "col-md-12 col-sm-12 col-lg-12": size == 2
      };
    },

    getBoardId(id) {
      for (let index = 0; index < this.sections.contentItems.length; index++) {
        const element = this.sections.contentItems[index];
        if (element.id == id) return this.sections.boardId;
      }
    },
    async handleDeleteProject(item) {
      let data = {
        trayId: this.getBoardId(item.id),
        productIds: this.selectedItemId
      };

      await this.resourceStringMyProject(
        this.$resourceString["common.accounts.Deleted.Msg"]
      );
      await this.deleteProjectFeatureItems(data);
    },
    projectSelected(itemId) {
      let checkIfExists = this.selectedItemId.indexOf(itemId);
      if (checkIfExists >= 0) {
        this.selectedItemId.splice(checkIfExists, 1);
      } else {
        this.selectedItemId.push(itemId);
      }
      this.updateSelectedTrayId(this.selectedItemId);
    }
  }
};
</script>
